/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PutPaymentRequestRequestEvidenceInvoiceIssuer } from './put-payment-request-request-evidence-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { PutPaymentRequestRequestSupplier } from './put-payment-request-request-supplier';

/**
 * 
 * @export
 * @interface PutPaymentRequestRequest
 */
export interface PutPaymentRequestRequest {
    /**
     * 
     * @type {PutPaymentRequestRequestSupplier}
     * @memberof PutPaymentRequestRequest
     */
    'supplier': PutPaymentRequestRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'transferFeeResponsibility': PutPaymentRequestRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestRequest
     */
    'withholdingCalculatingMethod': PutPaymentRequestRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof PutPaymentRequestRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {PutPaymentRequestRequestEvidenceInvoiceIssuer}
     * @memberof PutPaymentRequestRequest
     */
    'evidenceInvoiceIssuer': PutPaymentRequestRequestEvidenceInvoiceIssuer;
}

export const PutPaymentRequestRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type PutPaymentRequestRequestTransferFeeResponsibilityEnum = typeof PutPaymentRequestRequestTransferFeeResponsibilityEnum[keyof typeof PutPaymentRequestRequestTransferFeeResponsibilityEnum];
export const PutPaymentRequestRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type PutPaymentRequestRequestWithholdingCalculatingMethodEnum = typeof PutPaymentRequestRequestWithholdingCalculatingMethodEnum[keyof typeof PutPaymentRequestRequestWithholdingCalculatingMethodEnum];


